import type { ExpectedSlot } from "./planningModel";
import type { PlanningWeek } from "./types";
import type { WorkspaceState } from "./workspaceState";

export function isValidProposalMonth(month: string) {
  if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(month)) return false;
  const [year] = month.split("-").map(Number);
  return year >= 2000 && year <= 2100;
}

export function getCalendarProgress(
  workspace: WorkspaceState & { unscheduledSlots?: ExpectedSlot[] },
) {
  const scheduled = workspace.planningWeeks.flatMap((week) =>
    week.days.flatMap((day) => day.inMonth ? day.slots : []),
  );
  const unscheduled = workspace.unscheduledSlots ?? [];
  const ready = scheduled.filter((slot) => Boolean(slot.ideaId)).length;
  const total = scheduled.length + unscheduled.length;
  return { ready, total, unscheduled };
}

export function getWeekProgress(week: PlanningWeek) {
  const slots = week.days.flatMap((day) => day.inMonth ? day.slots : []);
  const ready = slots.filter((slot) => Boolean(slot.ideaId)).length;
  const counts = { story: 0, post: 0, reel: 0 };
  for (const slot of slots) counts[slot.contentType] += 1;
  return { ready, total: slots.length, counts };
}
